import React from 'react';
// import { useLocation } from 'react-router-dom';
import { Content, Lesson } from '../../../../../types';
import SectionContent from '../section-content/SectionContent';
import { useCourseContent } from '../../../../../hooks/useCourseContent';
import { LastVisitedLessonContentFragment } from '@api/graphql-codegen'

type Props = {
  contents: Content[];
  lesson?: Lesson;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
  isPreparation?: boolean;
};

function SectionContents(props: Props) {
  const { contents, lesson, lastVisitedLesson, closeNav, isPreparation } = props;
  const { content: selectedContent, lesson: selectedLesson } = useCourseContent();
  // const { content: selectedContent, lesson: selectedLesson, isParentApp } = useCourseContent();
  // const { pathname } = useLocation();
  // const [getSkills, { data }] = useSkillsLazyQuery();
  // useEffect(() => {
  //   if (isParentApp && pathname.startsWith('/parent/specialProgram')) {
  //     getSkills();
  //   }
  // }, [getSkills, isParentApp, pathname])

  // const otherSkills = useMemo(() => (data?.skills || []).filter(s => s?.id !== selectedContent?.id), [data?.skills, selectedContent?.id])

  return (
    <>
      {contents.map(content => {
        const sectionSelected = selectedContent?.id === content.id && (isPreparation || selectedLesson?.id === lesson?.id);
        return <SectionContent lastVisitedLesson={lastVisitedLesson} lesson={lesson} key={content.id} selected={sectionSelected} content={content as Content} closeNav={closeNav} />
      })}
      {/* {isParentApp && otherSkills && otherSkills.length > 0 && otherSkills.map(content => {
        const sectionSelected = selectedContent?.id === content?.id && selectedLesson?.id === lesson.id;
        return <SectionContent lastVisitedLesson={lastVisitedLesson} lesson={lesson} key={content?.id} selected={sectionSelected} content={content as unknown as Content}/>
      })} */}
    </>
  );
}

export default SectionContents;
